var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPackagedOrderEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.322 56.604h-4.065l-1.44-1.39c5.042-5.866 8.078-13.482 8.078-21.766C66.895 14.974 51.921 0 33.448 0 14.974 0 0 14.974 0 33.448c0 18.473 14.974 33.447 33.448 33.447 8.284 0 15.9-3.036 21.766-8.079l1.39 1.441v4.065L82.333 90 90 82.333l-25.678-25.73ZM49.115 33.37l-13.5-13.5c-.54-.54-1.29-.87-2.115-.87H23c-1.65 0-3 1.35-3 3v10.5c0 .825.33 1.575.885 2.13l13.5 13.5c.54.54 1.29.87 2.115.87.825 0 1.575-.33 2.115-.885l10.5-10.5c.555-.54.885-1.29.885-2.115a3.03 3.03 0 0 0-.885-2.13ZM25.25 26.5A2.247 2.247 0 0 1 23 24.25 2.247 2.247 0 0 1 25.25 22a2.247 2.247 0 0 1 2.25 2.25 2.247 2.247 0 0 1-2.25 2.25Zm8.198 30.104c-12.813 0-23.156-10.343-23.156-23.156 0-12.813 10.343-23.156 23.156-23.156 12.813 0 23.156 10.343 23.156 23.156 0 12.813-10.343 23.156-23.156 23.156Z",
    fill: "#B8B7B7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackagedOrderEmpty);
export default __webpack_public_path__ + "static/media/packaged-order-empty.12fac5414e28359c54336df390975e45.svg";
export { ForwardRef as ReactComponent };